import { DATA_PARASITE_LN_MODEL , getBaseURLforBackEnd , getConfigAxios  }  from '@/utils.js'
import axios from "axios";
import master_data from "./master_data";



export default {
    namespaced: true,

    state: {

        buffPARADatPrepareDat : "", //buffBACTDatPrepareDat : "",
        
        buffPARADatCtDat : "",  // buffBACTDatCtDat : "",
        dataPARASpecLN: Object.assign( {} ,DATA_PARASITE_LN_MODEL) , // dataBACTSpecLN: Object.assign( {} ,DATA_PARASITE_LN_MODEL) ,

        mstPARADat: [] , // mstBactDat: [] ,
        mstDrugPARADat: [] , // mstDrugDat: [] ,
        mstMicPARADat  : [] , // mstMicDat  : [] ,
        mstResultPARADat: [], // mstResultDat: [],
        mstMethodPARA:[], // mstMethod:[],
        mstMethodPARAResult:[], // mstMethodResult:[],
        tmplatePARA:{} // tmplateBact:{}
    },

    getters: {

    },

    mutations: {
        setMstMethodPARA (state, mstMethodPARA) {
            state.mstMethodPARA = mstMethodPARA
        },


        setMstMethodPARAResult (state, mstMethodPARAResult) {
            state.mstMethodPARAResult = mstMethodPARAResult
        },

         


        setTmplatePARA (state, tmplatePARA) {
            state.tmplatePARA = tmplatePARA
        },


        setMstResultPARADat (state, mstResultPARADat) {
            state.mstResultPARADat = mstResultPARADat
        },

        setMstMicPARADat (state, mstMicPARADat) {
            state.mstMicPARADat = mstMicPARADat
        },

        setMstDrugPARADat (state, mstDrugPARADat) {
            state.mstDrugPARADat = mstDrugPARADat
        },

        setMstPARADat (state, mstPARADat) {
            state.mstPARADat = mstPARADat
        },


        setDataPARASpecLN (state, dataPARASpecLN) {
            state.dataPARASpecLN =  dataPARASpecLN
        },

        setBuffPARADatPrepareDat (state, buffPARADatPrepareDat) {
            state.buffPARADatPrepareDat = buffPARADatPrepareDat
        },

        setBuffPARADatCtDat (state, buffPARADatCtDat) {
            state.buffPARADatCtDat = buffPARADatCtDat
        },

    },

    actions: {
        // produceDoneFetching({commit},doneFetching){
        //     commit('setDoneFetching', doneFetching)
        // },

        produceBuffPARADatPrepareDat({commit},buffPARADatPrepareDat){
            commit('setBuffPARADatPrepareDat', buffPARADatPrepareDat)
        },

        produceBuffPARADatCtDat({commit},buffDatCtDat){
            commit('setBuffPARADatCtDat', buffDatCtDat)
        },



        fetchMiscMasterDataForPARA({commit},datTo) {
            return new Promise((resolve) => {
                axios.defaults.headers.common['Authorization'] = `Bearer ${master_data.state.access_token}`
                axios.post(`${getBaseURLforBackEnd()}/api/getmiscmasterdataforparasite`,datTo,getConfigAxios())
                    .then((res)=>{
                        // console.log("fetchMiscMasterDataForPARA-->  ",res.data)
                        commit('setMstResultPARADat', res.data.result_mst)
                        commit('setMstMicPARADat', res.data.mic)
                        commit('setMstDrugPARADat', res.data.drug)
                        commit('setMstPARADat', res.data.bact)
                        commit('setTmplatePARA', res.data.tmplate)
                        commit('setMstMethodPARA', res.data.method_mst)
                        commit('setMstMethodPARAResult', res.data.method_result_mst)

                        resolve(res.data)
                    })
            }    )

        },


        fetchPARAOLDDat({commit},datTo){
            // console.log(datTo) 
            return new Promise((resolve) => {
                axios.defaults.headers.common['Authorization'] = `Bearer ${master_data.state.access_token}`
                axios.post(`${getBaseURLforBackEnd()}/api/labpara_by_spechnspecln`,datTo,getConfigAxios())
                    .then((res)=>{
                        // console.log("fetchPARAOLDDat---> ", JSON.stringify(res.data))
                        commit('setDataPARASpecLN', JSON.parse(JSON.stringify(res.data))  ) 
                        // commit('setBuffBACTDatPrepareDat', res.data.dat_prepare.dat)


                        // // const  tmp = res.data.dat_prepare.dat
                        // // console.log(tmp)
                        // // buffer.from("SGVsbG8gVmlzaGFsIFRoYWt1cg==", 'base64').toString('ascii')
                        if(res.data.dat_prepare.dat === null){
                            commit('setBuffPARADatPrepareDat',"")
                        }else{
                            commit('setBuffPARADatPrepareDat', Buffer.from(res.data.dat_prepare.dat, 'base64').toString('utf-8') )
                        }
                        // // **************************************************
                        if(res.data.dat_ct.dat === null){
                            commit('setBuffPARADatCtDat',"")
                        }else{
                            commit('setBuffPARADatCtDat', Buffer.from(res.data.dat_ct.dat, 'base64').toString('utf-8') )
                        }
                        // // console.log( Buffer.from(res.data.dat_prepare.dat, 'base64').toString('utf-8'))
                        resolve(res.data)
                    })
            })
        }
    }
}